export const SYLLABUS = {
  HKDSE: 'HKDSE',
};

export const SUBJECT = {
  MATH: 'Mathematics',
  ENGLISH: 'English',
  CHINESE: 'Chinese',
};
export const EXAMSUBJECT = {
  math: 'Mathematics',
  english: 'English',
  chinese: 'Chinese',
  biology: 'Biology',
  physics: 'Physics',
  chemistry: 'Chemistry',
  economics: 'Economics',
};

export const EXAMLEVEL = {
  SL: 'SL',
  HL: 'HL',
};

export const FORMAT = {
  MOCK: 'MOCK',
  WORKSHEET: 'WORKSHEET',
};

export const PAPER = {
  P1: 'P1',
  P2: 'P2',
};

export const ENG_SUB_PAPER = {
  A: 'A',
  B1: 'B1',
  B2: 'B2',
};

export const LANGUAGE = {
  ENG: 'ENGLISH',
  CHI: 'CHINESE',
};

export const LEVEL = {
  junior: 'S1-S3',
  senior: 'S4-S6',
  all: '',
};

export const formSteps = [
  { label: 'Format' },
  { label: 'Details' },
  { label: 'Confirm' },
];

export const TopicItemHeight = 70;
export const TopicItemMargin = 2;

export const ENG_WRITING_MARKING_COMPONENTS = {
  content: 'Content',
  language_and_style: 'Language and Style',
  organization: 'Organization',
};

export const CHI_WRITING_MARKING_COMPONENTS = {
  content: '內容',
  language_and_style: '表達',
  organization: '結構',
};

export const submissionConfig = {
  extendedTime: 3600, // in seconds
}

export const FULL_DATE_FORMAT = 'dddd DD MMM YYYY, HH:mm'
export const DATE_FORMAT = 'dddd DD MMM YYYY'
export const TIME_FORMAT = 'HH:mm'
export const SUBMISSION_LIMIT = 2 // => user will only be allowed to submit for this number, if this variable set as 0 => then there will be no limit in how many time user upload a submission paper
